// @flow
import React from 'react';
import SendProfileButton from 'app/common/react/components/sending/SendProfileButton';
import type { ProfileUser } from 'app/packages/pinterest-flow-types/user';

type Props = {
  user: ProfileUser,
};
type State = {
  isProfileSendOpen: boolean,
};

export class SendProfileButtonController extends React.Component<Props, State> {
  state: State = {
    isProfileSendOpen: false,
  };

  handleSendProfileToggle = () => {
    this.setState({ isProfileSendOpen: !this.state.isProfileSendOpen });
  };

  handleSendProfileDismiss = () => {
    this.setState({
      isProfileSendOpen: false,
    });
  };

  render() {
    const { user } = this.props;
    return (
      <SendProfileButton
        userId={user.id}
        gridDescription=""
        sendType="user"
        fullName={user.full_name}
        profileUrl={`/${user.username}/`}
        imageSrc={user.image_large_url}
        onToggleFlyout={this.handleSendProfileToggle}
        onFlyoutDismiss={this.handleSendProfileDismiss}
        isFlyoutOpen={this.state.isProfileSendOpen}
      />
    );
  }
}

export default SendProfileButtonController;
